import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ClausesUtil } from '@xengage/gw-policycommon-util-js';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import './CoveragesPage.messages';
import styles from '../../SportsAndRecPage.module.scss'
import presentationMetadata from './CoveragesPage.metadata.json5';

function CoveragesPage(props) {
    const { authHeader } = useAuthentication();
    const [loadingClause, updateLoadingClause] = useState();
    const {
        wizardData: submissionVM, updateWizardData,isEditable = true, clausesBasePath, title, clasueType, pathToGet
    } = props;
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { EndorsementService } = useDependencies('EndorsementService');
    const metadata = presentationMetadata["SpoAndRecProduct.default.coverages"];
    const breakpoint = useContext(BreakpointTrackerContext);
    const {
        onValidate,
        registerComponentValidation,
        registerInitialComponentValidation
    } = useValidation('CoveragesPage');

    const changeSubmission = useCallback(
        (value, changedPath) => {
            updateWizardData(
                ClausesUtil.setClauseValue(submissionVM, value, changedPath)
            );
        },
        [submissionVM, updateWizardData]
    );

    const syncCoverages = useCallback(async (value, changedPath) => {
        updateLoadingClause(true)
        
        const basePath = ClausesUtil.getObjectPathFromChangedPath(changedPath);
        let baseObject = _.get(submissionVM, basePath);
        const { jobType } = submissionVM.value.baseData;
        const jobService = jobType === 'PolicyChange' ? EndorsementService : LoadSaveService;
        const { quoteID, jobID, sessionUUID } = submissionVM.value;
        const lobName = ClausesUtil.getLobNameFromPath(clausesBasePath);

        if (!baseObject) {
            const escapedClausesBasePath = clausesBasePath.replace(/\[/g, '\\[').replace(/\]/g, '\\]');
            // eslint-disable-next-line no-secrets/no-secrets
            const clausesPath = changedPath.match(`${escapedClausesBasePath}.(errorsAndOmisionCoverages|cyberPrivacyBreachCoverageExtension|commercialGeneralLiability)`)[0];
            const baseObjectArray = _.get(submissionVM.value, clausesPath);
            const selectedBaseObject = baseObjectArray.filter((data) => data.updated === true);

            // eslint-disable-next-line prefer-destructuring
            baseObject = selectedBaseObject[0];
        }

        const clausesToUpdate = [clasueType].reduce((payloadToSend, clauseType) => {
            let clausePathValue = _.get(submissionVM, `${clausesBasePath}.value`);

            if (!clausePathValue) {
                clausePathValue = _.get(submissionVM.value, `${clausesBasePath}.${clauseType}`);
            }

            const clauses = clausePathValue || [];

            return _.merge(
                payloadToSend,
                ClausesUtil.structureClausesForServer(clauses, lobName, clauseType)
            );
        }, {});

        const findCovUpdated = clausesToUpdate.spoAndRecLine.coverages[0].terms.find((term) => term.updated)

        if(findCovUpdated?.directValueMax !== undefined &&
            findCovUpdated?.directValue > findCovUpdated?.directValueMax) {

                updateLoadingClause(false)

                return false;
        }

        const res = await jobService.updateCoverages(quoteID || jobID, sessionUUID, clausesToUpdate, authHeader);// await updateClauses();
        const clausesBasePathTemp = clausesBasePath.indexOf('children') !== -1? clausesBasePath.replace('.children', ''):clausesBasePath
        const updatedCov = _.get(res, pathToGet)
        
        _.set(submissionVM.value, clausesBasePathTemp, updatedCov)
        //submissionVM.value = res
        
        updateLoadingClause(false)
        updateWizardData(submissionVM);

    }, [submissionVM, EndorsementService, LoadSaveService, clausesBasePath, clasueType, authHeader, pathToGet, updateWizardData]);


    const changeSubmissionAndSync = useCallback(
        (value, changedPath) => {
            changeSubmission(value, changedPath);
            syncCoverages(value, changedPath);
        },
        [changeSubmission, syncCoverages]
    );

    const resolvers = {
        resolveCallbackMap: {
            onChangeClause: changeSubmission,
            onSyncCoverages: syncCoverages,
            onChangeSubmissionAndSync: changeSubmissionAndSync,
            onValidate,
        },
        resolveClassNameMap: styles
    };

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        coverages: {
            loadingClause,
            path: `${clausesBasePath}`,
            isEditable,
            value: _.get(submissionVM, `${clausesBasePath}.value`)
        },
        coverageAccordionDetails: {
            title
        }
    };


    const isPageLoading = useCallback(() => _.isUndefined(loadingClause), [loadingClause]);

    useEffect(() => {
        registerComponentValidation(isPageLoading);
    }, [
        isPageLoading,
        registerComponentValidation,
        registerInitialComponentValidation,
    ]);

    return (
        <ViewModelForm
            uiProps={metadata.content}
            model={submissionVM.value}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onModelChange={updateWizardData}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

CoveragesPage.propTypes = {
    ...wizardProps
};

export default CoveragesPage;
